import { render, staticRenderFns } from "./OptionEditEnabledIfTab.vue?vue&type=template&id=4055fe8c"
import script from "./OptionEditEnabledIfTab.vue?vue&type=script&lang=ts"
export * from "./OptionEditEnabledIfTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports